import { render, staticRenderFns } from "./StorageRowItem.vue?vue&type=template&id=6a1f96d0&"
import script from "./StorageRowItem.vue?vue&type=script&lang=js&"
export * from "./StorageRowItem.vue?vue&type=script&lang=js&"
import style0 from "./StorageRowItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports